<template>
  <el-dialog :title="title" :visible="dialogFormVisible"  :before-close="handleClose" :closeOnClickModal="false">
        <el-form :label-width="labelwidth" ref="model" :model="model" :rules="rules" :label-position="labelPosition" >
            <el-form-item label="负责人" prop="Manager">
                <el-input size="small" v-model="model.Manager" auto-complete="off" placeholder="请输入负责人" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="应用名称" prop="Name">
                <el-input size="small" v-model="model.Name" auto-complete="off" placeholder="请输入应用名称" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="授权方式" prop="AuthType">
                <el-radio-group v-model="model.AuthType">
                    <el-radio label="永久授权"></el-radio>
                    <el-radio label="限时授权"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="到期时间" prop="DueTime" v-if="model.AuthType == '限时授权'">
                <el-date-picker
                    v-model="model.DueTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    default-time="12:00:00">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="IP白名单" prop="IPList">
                <el-input size="small" v-model="model.IPList" auto-complete="off" placeholder="请输入IP白名单" maxlength="100"></el-input>
                <p style="color:red;line-height:1">注意：多个ip之间请用分号隔开</p>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='handleClose'>取消</el-button>
        <el-button size="small" type="primary"  class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {AddWorkSQ} from '../../api/authorize'
export default {
    data() {
        return {
            title: '添加授权',
            name: 'add',
            labelwidth: '120px',
            labelPosition: 'right',
            baseURL: window.Global.baseURL,
            model: {
                Manager:'',
                Name: '',
                AuthType: '',
                DueTime: '',
                IPList: '*'
            },
            rules: {
                Manager: [{ required: true, message: '请输入应用负责人', trigger: 'blur' }],
                Name: [{ required: true, message: '请输入应用名称', trigger: 'blur' }],
                AuthType: [{ required: true, message: '请选择授权方式', trigger: 'change' }],
                DueTime: [{ required: true, message: '请选择到期时间', trigger: 'change' }],
            },
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        }
    },
    mounted() {
        this.init();
    },  
    methods: {
        init() {
           
        },
        handleSave() {
            this.$refs.model.validate((valid) => {
                if (valid) {
                    this.AddWorkSQ()
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'error'
                    });
                }
            });
            
        },
        handleClose() {
            this.$emit('closeAddDialog')
        },
        AddWorkSQ() {
            let AuthType;
            let DueTime;
            if(this.model.AuthType === '永久授权') {
                AuthType = 1;
            }else if(this.model.AuthType === '限时授权') {
                AuthType = 2;
            }

            AddWorkSQ({
                Manager: this.model.Manager,
                Name: this.model.Name,
                AuthType: AuthType,
                DueTime: this.model.DueTime,
                IPList: this.model.IPList
            }).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.handleClose();
                }
            })
        },
        
    }
}
</script>

<style>

</style>